<template>
  <div class="login relative py-32">
    <OImage v-bind="image" />
    <div class="mt-16 md:mt-0 container flex items-center justify-center">
      <LoginForm
        class="md:w-1/2 shadow-md"
        :country="country"
        :loading="loading"
        @login="login"
      />
    </div>
  </div>
</template>

<script>
import { IS_AUTHENTICATED } from '@/utils/store/getterTypes'
import { mapGetters, mapState } from 'vuex'
import { getImagePaths } from '@/utils/general'
import LoginForm from '@/components/Forms/LoginForm'
const OImage = () => import('@/components/OImage')

export default {
  name: 'LoginPage',
  auth: 'guest',
  components: {
    OImage,
    LoginForm
  },
  layout: 'default',
  data () {
    return {
      loading: false,
      PasswordResetLink: {
        link: this.$i18n.localePath({ name: 'password-reset' }),
        title: this.$t('LoginForm.PasswordReset')
      }
    }
  },
  computed: {
    ...mapGetters('auth', {
      isAuthenticated: IS_AUTHENTICATED
    }),
    ...mapState('app', {
      country: state => state.country
    }),
    ...mapState('auth', {
      redirectUrl: state => state.redirectUrl
    }),
    disableUserFetching () {
      const paths = []
      return paths.some(path => this.redirectUrl.includes(path))
    },
    image () {
      return getImagePaths({ path: '/images/frontend/static/login-men-originals', s3: true })
    }
  },
  methods: {
    login (form) {
      this.loading = true

      const shouldDisableUserFetching = this.disableUserFetching

      const url = this.$route.query.next ?? this.redirectUrl

      // Login and fetch user
      this.$auth.login({ ...form, url, disableUserFetching: shouldDisableUserFetching })
        .then(() => {
          this.loading = false
          this.$otoaster.success(this.$t('LoginForm.LoginSuccessful'))

          const { chatId, locale } = this.$route.query

          if (chatId && locale) {
            const url = `${process.env.CHATBOT_BASE_URL}/${locale}/chat/${chatId}`

            window.location = url
          }
        })
        .catch((e) => {
          this.$ota.general.logError(e)
          this.loading = false

          try {
            const message = JSON.parse(e?.request?.response)?.message

            if (message === 'User is not activated for login') {
              this.$otoaster.danger(this.$t('LoginForm.LoginFailedNotVerified'))
            } else if (message.includes('Too many failed login attempts')) {
              const extractMinutes = (string) => {
                const minutes = string.match(/\d+/)[0]
                return minutes
              }

              this.$otoaster.danger(this.$t('LoginForm.TooManyFailedLoginAttempts', { minutes: extractMinutes(message) }))
            } else {
              this.$otoaster.danger(this.$t('LoginForm.LoginFailed'))
            }
          } catch (error) {
            this.$otoaster.danger(this.$t('LoginForm.LoginFailed'))
          }
        })
    }
  }
}
</script>

<style lang="postcss" scoped>
.login {
  .oimage >>> img {
    @apply object-cover absolute top-0 right-0 left-0 bottom-0 !important;
    max-width: 100% !important;
    min-width: 100% !important;
    max-height: 100% !important;
    min-height: 100% !important;
  }

  &:after {
    @apply absolute h-full w-full top-0 left-0 z-0;
    content: '';
    background: rgba(51,51,51, 0.1);
  }
}
</style>
